"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

var _react = _interopRequireDefault(require("react"));

var _Input = require("./Input.Styled");

var _reactNumberFormat = require("react-number-format");

const _excluded = ["onChange", "value", "type", "placeholder", "className", "isBasic", "required"],
      _excluded2 = ["type", "label"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const Basic = _ref => {
  let {
    onChange: _onChange,
    value,
    type,
    placeholder,
    className,
    isBasic,
    required = false
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_Input.StyledInput, {
    onChange: e => _onChange(isBasic ? e.target.value : e),
    type: type || 'text',
    value: value || '',
    placeholder: placeholder,
    required: required,
    className: className
  });
};

const Int = _ref2 => {
  let {
    value,
    onChange,
    placeholder,
    suffix,
    prefix
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_reactNumberFormat.NumericFormat, {
    value: value,
    isAllowed: values => {
      const {
        value
      } = values;
      return !value.includes('.');
    },
    onValueChange: values => onChange(values.floatValue),
    customInput: Basic,
    thousandsGroupStyle: "thousand",
    thousandSeparator: ".",
    decimalSeparator: ",",
    placeholder: placeholder,
    suffix: suffix,
    prefix: prefix
  });
};

const Float = _ref3 => {
  let {
    value,
    onChange,
    placeholder,
    suffix,
    prefix
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(_reactNumberFormat.NumericFormat, {
    onValueChange: values => onChange(values.floatValue),
    value: value,
    customInput: Basic,
    decimalSeparator: ",",
    thousandsGroupStyle: "thousand",
    thousandSeparator: ".",
    placeholder: placeholder,
    suffix: suffix,
    prefix: prefix
  });
};

const Number = _ref4 => {
  let {
    value,
    onChange,
    placeholder
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(_reactNumberFormat.NumericFormat, {
    decimalSeparator: ",",
    onValueChange: values => onChange(values.floatValue),
    value: value,
    customInput: Basic,
    placeholder: placeholder
  });
};

const Input = _ref5 => {
  let {
    type = 'text',
    label
  } = _ref5,
      props = _objectWithoutProperties(_ref5, _excluded2);

  if (typeof props.onChange !== 'function') return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);

  const selectComponent = () => {
    switch (type) {
      case 'int':
        return /*#__PURE__*/_react.default.createElement(Int, props);

      case 'float':
        return /*#__PURE__*/_react.default.createElement(Float, props);

      case 'number':
        return /*#__PURE__*/_react.default.createElement(Number, props);

      default:
        return /*#__PURE__*/_react.default.createElement(Basic, _extends({
          isBasic: true,
          type: type
        }, props));
    }
  };

  return /*#__PURE__*/_react.default.createElement(_Input.Wrapper, null, label && /*#__PURE__*/_react.default.createElement(_Input.Label, null, label), selectComponent());
};

var _default = Input;
exports.default = _default;